import { RenderUnsettledUI } from 'shared/components';
import { useParams } from 'react-router-dom';
import { invariant } from 'shared/utils/utils';
import { ProjectFormTypeDuplicate } from 'shared/components/project-forms/types/project-form.types';
import { mapProjectToDetails } from 'api/services/work-template/work-template.utils';
import { ProjectDuplicateFormPage } from './form/project-duplicate-form-page';
import { useGetProjectDetail } from '../../../../../../../shared/components/planner/project-detail-modal/detail/applications/hooks/use-get-project-detail';

export const ProjectDuplicateDataProvider = () => {
  const { id: projectId } = useParams<'id'>();
  invariant(projectId, 'Project ID is not specified');

  const projectQuery = useGetProjectDetail(projectId);

  if (projectQuery.status !== 'success') {
    return <RenderUnsettledUI data={projectQuery} />;
  }

  const defaultValues: Partial<ProjectFormTypeDuplicate> = {
    departmentId: projectQuery.data.department.id,
    startDate: projectQuery.data.startDate,
    endDate: projectQuery.data.endDate,
    weeklyHours: projectQuery.data.weekHourVolume,
    hourlyRate: (projectQuery.data.freelanceProperties?.hourlyRateCents ?? 0) / 100,
    isTempwork: !!projectQuery.data.tempWorkProperties,
    isFreelance: !!projectQuery.data.freelanceProperties,
    location: projectQuery.data.location ?? null,
    isFreelanceOrtApplicable: projectQuery.data.freelanceProperties?.ortApplicable ?? false,
    isTempworkOrtApplicable: projectQuery.data.tempWorkProperties?.ortApplicable ?? false,
  };

  return (
    <ProjectDuplicateFormPage
      ancestorProjectId={projectId}
      defaultValues={defaultValues}
      successMessage={`Project ${projectQuery.data.name} duplicated`}
      pageTitle={`Project ${projectQuery.data.name} dupliceren`}
      workDetails={mapProjectToDetails(projectQuery.data)}
    />
  );
};
